<template>
  <div>
    <div v-if="$route.params.documentid" class="top-level-div container">
      <!-- <img :src="require(`../../../assets/img/logo/${$store.getters.logo}`)" width="" :height="$store.getters.logoHeight" :alt="$store.getters.agencyHumanName" id="ignorePDF" class="center"> -->
      <h3 class="center mt-2">{{ documentToView.title }}</h3>
      <hr>
      <pre v-html="documentToView.body"></pre>
    </div>

    <div v-if="!$route.params.documentid" class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;" id="ignorePDF"> -->
      <!-- <img :src="require(`../../../assets/img/logo/${$store.getters.logo}`)" width="" :height="$store.getters.logoHeight" :alt="$store.getters.agencyHumanName" id="ignorePDF" class="center"> -->
      <h3 class="center mt-2">{{ document.title }}</h3>
      <!-- {{ document }} -->
      <hr>

      <!-- <div class="mb-4" v-if="document.edit_access == 'All' || (document.edit_access == 'Admin' && $store.getters.isAgent === true) || (document.edit_access == 'User' && document.signing_user == user.id)"> -->
      <!-- <div class="mb-2" v-if="$store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id)"> -->
      <div class="mb-2" v-if="$store.getters.isAgent === true && !downloadingPDF" id="ignorePDF">
        <h3 style="margin-bottom: -10px;">Admin Only</h3>
        <div v-for="(field, index) in document.fields_labels" :key="'Field'+index" class="field-of-fields">
          <label>{{ field }}<span v-if="document.fields_required[index] === true">*</span></label>
          <textarea class="form-control" rows="3" v-model="fields[index]"></textarea>
        </div>
        <button class="mylisting-button dark-button mt-3 mb-3" @click="save()">Update</button>
        <hr>
        <hr>
      </div>

      <div v-if="document.status == 'Signed' || document.status == 'Saved'">
        <pre v-html="documentBody"></pre>
      </div>
      <div v-else>
        <div v-if="(document.status == 'Unsigned') && ($store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id))">
          <!-- <pre v-html="documentBody"></pre> -->
          <!-- <div v-if="fields.length"> -->
            <!-- <div v-for="(field, index) in document.fields_labels" :key="'Field'+index" class="field-of-fields"> -->
              <!-- <pre v-html="documentBody[index]" style=""></pre>
              <textarea class="form-control" rows="1" v-model="fields[index]"></textarea> -->

              <!-- Need to display the last segment of text -->
              <!-- <pre v-if="index == (fields.length - 1)" v-html="documentBody[index+1]"></pre> -->
            <!-- </div> -->
          <!-- </div> -->
          <!-- <div v-else>
            <pre v-html="documentBody"></pre>
          </div> -->

          <div v-for="(segment, index) in documentBody" :key="'Document Segment'+index">
            <pre v-if="checkIfNotNumber(segment)" v-html="segment"></pre>
            <textarea style="margin-top: -5px;" v-else class="form-control" rows="1" v-model="fields[parseInt(segment)]"></textarea>
          </div>
        </div>
        <div v-else>
          <pre v-html="documentBody"></pre>
        </div>
      </div>

      <!-- <p>{{ documentBody }}</p> -->

      <!-- <div class="mb-5" v-if="$store.getters.isAgent === true">
        <button class="mylisting-button dark-button mt-3" @click="save()">Update (Admin Only)</button>
      </div> -->
      <!-- Only show the save progress button if the document is unsigned, has fields to fill, and is being viewed by an admin or is not admin fillable only -->
      <div class="mb-5" v-if="document.status == 'Unsigned' && fields.length && ($store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id))">
        <button class="mylisting-button dark-button mt-3" @click="save()">Save Progress</button>
      </div>

      <!-- {{ template }} -->
      <!-- <pre>{{ template.body }}</pre> -->
      <!-- <pre v-html="template.body"></pre> -->
      <!-- <pre v-html="document.body"></pre> -->
      <!-- <pre v-html="documentBody" class="mt-5"></pre> -->

      <!-- <div v-if="document.edit_access == 'All' || (document.edit_access == 'Admin' && $store.getters.isAgent === true) || (document.edit_access == 'User' && document.signing_user == user.id)"> -->
      <div v-if="$store.getters.isAgent === true || document.signing_user == user.id">
        <!-- <div v-for="(signer_label, index) in template.signer_labels" :key="'Signer'+index"> -->
        <div v-for="(signer_label, index) in document.signer_labels" :key="'Signer'+index">
          <p style="font-weight: 600; margin-bottom: 0;">{{ signer_label }}</p>
          <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
          <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
          <h4 v-if="signatures[index]" style="font-family: 'Arizonia'; text-transform: none;">{{ signatures[index] }}</h4>
          <h4 v-if="!signatures[index]">___________</h4>
          <p v-if="document.status == 'Signed'">{{ document.signers[index] }}</p>

          <div v-if="document.status == 'Unsigned'">
            <input type="text" class="form-control" v-model="signatures[index]" style="max-width: 700px;">
            <label class="mt-1">Please type your name to sign (you agree that this constitutes the equivalent of signing a physical document)</label>
            <div>
              <button v-if="!signatures[index]" class="mylisting-button disabled-button mt-3 mb-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
              <button v-if="signatures[index] && requiredFieldsFilled" class="mylisting-button dark-button mt-3 mb-3" @click="sign()">Sign</button>
              <p v-else><strong>You are missing a required field.</strong></p>
            </div>
          </div>
        </div>
      </div>

      <!-- If this is a document that doesn't require a signature -->
      <div v-if="!document.signer_labels.length && !document.deactivated && document.status == 'Unsigned'">
        <div v-if="$store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id)">
          <button v-if="requiredFieldsFilled" class="mylisting-button dark-button mt-3" @click="saveSign()">Complete</button>
          <p v-else><strong>You are missing a required field.</strong></p>
        </div>
      </div>

      <!-- <div v-if="template.organization_signer"> -->
      <div v-if="template.organization_signer">
        <p style="font-weight: 600; margin-top: 25px; margin-bottom: 0;">{{ $store.getters.agencyHumanName }}</p>
        <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
        <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
        <!-- <h4 v-if="template.organization_signer" style="font-family: 'Arizonia'">{{ template.organization_signer }}</h4> -->
        <!-- <p>Per: {{ template.organization_signer }}</p> -->
        <h4 v-if="document.organization_signer" style="font-family: 'Arizonia'; text-transform: none;">{{ document.organization_signer }}</h4>
        <p>Per: {{ document.organization_signer }}</p>
      </div>

      <!-- {{ document.fields_required }}

      <p>{{ requiredFieldsFilled }}</p> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {

  // title: template.name,
  // template: template.id,
  // signing_user: this.user.id,
  // status: 'Unsigned',
  // body: template.body,
  // fields_labels: template.fields,
  // fields_required: template.fields_required,
  // edit_access: template.edit_access,
  // organization_signer: template.organization_signer,
  // signer_labels: template.signer_labels,
  // agency_owner: this.$store.getters.agencyName,
  // agency: this.$store.getters.agencyID,

  props: ['user', 'document', 'downloadingPDF'],
  data() {
    return {
      template: {},
      signatures: [],
      signature: '',
      fields: [],

      documentToView: {},
    }
  },
  created() {
    if (this.document) {
      this.getTemplate()

      // Replace all instances of the auto fill fields
      this.document.body = this.document.body.split(`[[fname]]`).join(this.user.first_name)
      this.document.body = this.document.body.split(`[[lname]]`).join(this.user.last_name)
      if (this.user.features[0]) {
        this.document.body = this.document.body.split(`[[parent2_fname]]`).join(this.user.features[0])
      }
      if (this.user.features[1]) {
        this.document.body = this.document.body.split(`[[parent2_lname]]`).join(this.user.features[1])
      }
      this.document.body = this.document.body.split(`[[email]]`).join(this.user.email)
      this.document.body = this.document.body.split(`[[phone]]`).join(this.user.phone)
      if (this.user.features[2]) {
        this.document.body = this.document.body.split(`[[parent2_email]]`).join(this.user.features[2])
      }
      if (this.user.features[3]) {
        this.document.body = this.document.body.split(`[[parent2_phone]]`).join(this.user.features[3])
      }
      this.document.body = this.document.body.split(`[[date]]`).join(new Date().toDateString())
      let address = this.user.address1
      if (this.user.address2) { // Not everyone has a second line in their address, don't want an extra space if they don't
        address = address + ' ' + this.user.address2
      }
      address = address + ', ' + this.user.city + ', ' + this.user.provincestate + ', ' + this.user.postal_code
      this.document.body = this.document.body.split(`[[address]]`).join(address)
      // Create a list of all the children
      let children = this.user.features2[0]
      if (this.user.features2[2]) { children += `, ${this.user.features2[2]}` }
      if (this.user.features2[4]) { children += `, ${this.user.features2[4]}` }
      if (this.user.features2[6]) { children += `, ${this.user.features2[6]}` }
      this.document.body = this.document.body.split(`[[children]]`).join(children)

      // console.log(this.document.fields)
      if (this.document.fields.length) { // This would mean the document has been filled before
        this.fields = this.document.fields
      }
      else { // If the document is not already filled, want to prepopulate the fields array with blanks for use with v-model
        for (var label in this.document.fields_labels) {
          this.fields.push('')
        }
      }

      // console.log(this.fields)

      // let thing = '[[field0]]'
      // this.document.body = this.document.body.replace(thing, 'blahhh')
      // console.log('boop')
      // console.log(this.fields)
      // for (var field in this.fields) {
      //   console.log('poop')
      //   this.document.body = this.document.body.replace(`[[field${field}]]`, this.fields[field])
      // }
    }

    if (this.$route.params.documentid) {
      this.getDocumentToView()
    }
  },
  computed: {
    // documentBody() {
    //   let documentBody = this.document.body
    //   let num = 0
    //   let thing = `[[field${num}]]`
    //   // documentBody = documentBody.replace(`[[field1]]`, this.fields[1])
    //   for (var field in this.fields) {
    //     // console.log('poop')
    //     // documentBody = documentBody.replace(`[[field${field}]]`, this.fields[field])
    //     // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
    //     documentBody = documentBody.split(`[[field${field}]]`).join(this.fields[field])
    //   }
    //   // documentBody = documentBody.replace(thing, 'blahhblah')

    //   return documentBody
    // }

    documentBody() {
      let documentBody = null
      if (this.fields.length) { // If the document has fields to fill and is not deactivated, we want to show the fields
        if (this.document.status == 'Signed' || this.document.status == 'Saved' || (this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID)) {
          documentBody = this.document.body
          // console.log(documentBody)
        }
        else if (this.document.status == 'Unsigned') {
          // this.document.body = this.document.body.split(`[[fname]]`).join(this.user.first_name)
          // this.document.body = this.document.body.split(`[[lname]]`).join(this.user.last_name)

          documentBody = []
          documentBody[0] = this.document.body
          // console.log(this.document.body)
        }
        let num = 0
        // let thing = `[[field${num}]]`
        // documentBody = documentBody.replace(`[[field1]]`, this.fields[1])
        for (var field in this.fields) {
          // if (this.document.status == 'Signed') { // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
          if (this.document.status == 'Signed' || this.document.status == 'Saved' || this.document.deactivated || (this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID)) { // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
            console.log(`[[field${field}]]`)
            // documentBody = documentBody.replace(`[[field${field}]]`, this.fields[field])
            // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
            documentBody = documentBody.split(`[[field${field}]]`).join(this.fields[field])
          }
          else if (this.document.status == 'Unsigned') { // If the document has not been signed or is not one that needs to be signed, we want to split it into pieces at each of the [field] references, so we can display inline text boxes to fill it
            // documentBody[field] = documentBody[field].split(`[[field${field}]]`)

            // let remainingDocument = documentBody.pop() // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
            // documentBody = documentBody.concat(remainingDocument.split(`[[field${field}]]`)) // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat

            // ------
            // The goal is to handle fields being repeated, and being out of order

            // Start with the document body string:
            // ‘blah blah blah [[field1]] blah blah [[field3]] blah blah [[field2]] blah blah [[field1]] blahblah’

            // Turn the document body string into a list:
            // [‘blah blah blah [[field1]] blah blah [[field3]] blah blah [[field2]] blah blah [[field1]] blahblah’]

            // For each field X in the document (field0, field1, field2….):
            //   For each element in the document body list:
            //     split the document body element by ‘fieldX’
            //     eg. split documentBody[0] on [[field1]]
            //     [‘blah blah blah ’, ‘ blah blah [[field3]] blah blah [[field2]] blah blah ‘, ‘ blahblah’]

            //     for each element in the list add it back to a new list, and after each addition also add an element ‘fieldX’ (only add it at the end of the list if the last element is “” [an empty string], because that means the last part of the string was fieldX)

            let documentBodyPlaceholder = [] // As we breakdown each segment of the document body, we add it back to the placeholder. Once we have gone through every segment, we update the document body with the placeholder
            // console.log(documentBody)
            for (var segment in documentBody) { // For each segment of the document body, we want to split it on all instances of the current fieldX
              // console.log(documentBody[segment])
              documentBody[segment] = documentBody[segment].split(`[[field${field}]]`)
              for (var innerSegment in documentBody[segment]) { // For each spot where we split, we want to push the number of the field we split on as a marker for displaying the textarea
                documentBodyPlaceholder.push(documentBody[segment][innerSegment])
                if (innerSegment == (documentBody[segment].length - 1)) { // If we are looking at the last inner segment of the segment
                  if (documentBody[segment][innerSegment] == '') { // If it is an empty string, that means the segment had fieldX at the end, so we need to push another field marker
                    documentBodyPlaceholder.push((field))
                  }
                }
                else {
                  documentBodyPlaceholder.push((field))
                }
              }
            }
            // console.log(documentBodyPlaceholder)
            // console.log(documentBody)
            documentBody = documentBodyPlaceholder
          }
        }
        // documentBody = documentBody.replace(thing, 'blahhblah')
      }
      else {
        // documentBody = this.document.body
        documentBody = []
        documentBody[0] = this.document.body
      }

      return documentBody
    },
    requiredFieldsFilled() {
      if (this.fields.length) {
        // console.log(this.fields)
        // console.log(this.document.required_fields)
        for (var field in this.fields) {
          // For each field, check if it has been filled and it's required
          if (!this.fields[field] && this.document.fields_required[field]) {
            return false
          }
        }
        return true
      }
      else { // If there are no fields to fill, a required field can't be missing
        // return null
        return true
      }
    },
  },
  methods: {
    getDocumentToView() {
      axios.get(`/api/documents/?id=${this.$route.params.documentid}`)
        .then(res => {
          console.log(res)
          this.documentToView = res.data[0]
        })
        .catch(error => console.log(error))
    },
    getTemplate() {
      axios.get(`/api/documenttemplates/?id=${this.document.template}`)
        .then(res => {
          this.template = res.data[0]

          if (this.document.status == 'Unsigned') {
            for (var signer_label in this.template.signer_labels) {
              this.signatures.push('')
            }
          }
          else if (this.document.status == 'Signed') {
            this.signatures = this.document.signers
          }
        })
        .catch(error => console.log(error))
    },
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signers: this.signatures,
        signing_date: this.todayDatetimeDjangoFormat,
        fields: this.fields,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    saveSign() {
      //
      // This is when a document isn't technically "signed", but just saving information
      // (still want to set the status to signed since that means it's completed)
      //
      axios.patch(`/api/documents/${this.document.id}/`, {
        fields: this.fields,
        // status: 'Signed',
        status: 'Saved',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    save() {
      //
      // This is for saving a document information without marking it as signed
      // Primarily for admins setting up documents for users to sign
      //
      axios.patch(`/api/documents/${this.document.id}/`, {
        fields: this.fields,
        // status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSaved')
          // console.log('Document Saved')
        })
        .catch(error => {
          console.log(error)
        })
    },

    checkIfNotNumber(segment) {
      return isNaN(segment)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/Document.vue